import { render, staticRenderFns } from "./UnterrichtConfiguration.vue?vue&type=template&id=5b704e5d&scoped=true"
import script from "./UnterrichtConfiguration.vue?vue&type=script&lang=ts"
export * from "./UnterrichtConfiguration.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b704e5d",
  null
  
)

export default component.exports